// extracted by mini-css-extract-plugin
export default {"colors":"\"../styles/colors.css\"","primaryColor":"#3A237B","timer":"CountdownTimer_timer__SiPCS","danger":"CountdownTimer_danger__nB06-"};